<template>
  <div class="sp-mock-banner">
    <i class="pi pi-info-circle"></i>
    <span>
      <strong>Mock-up for discussion.</strong> Sample data from real TEST enquiries. Nothing on this page is saved, and buttons that would
      change data are switched off.
      <slot />
    </span>
  </div>
</template>

<script>
export default { name: 'MockBanner' }
</script>

<style scoped>
.sp-mock-banner {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  background: #fff8e1;
  border: 1px solid #ffcc80;
  color: #6d4c00;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 14px;
  font-size: 13px;
}
.sp-mock-banner .pi { margin-top: 2px; }
</style>
